export default __webpack_public_path__ + "static/media/pf.2c14ae64.svg";